<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import {
        Button, UserItem, OutputUser, Modal, Tooltip, SESSION,
        openModal,
    } from '@smatch/cassiopeia-web-components';

    // COMPONENTS
    import AuctionItemDownload from './AuctionItemDownload.svelte';
    import AuctionItemInfo from '../components/AuctionItemInfo.svelte';
    import AuctionReservedBidForm from './AuctionReservedBidForm.svelte';

    /* TYPES ----------------------------------------------------------------------------------- */

    import type { Auction } from 'src/app/types';

    /* EXPORTS --------------------------------------------------------------------------------- */

    export let auction: Auction;
    export let isPreview: boolean = false;

    /* INTERNALS -------------------------------------------------------------------------------- */

    const SUBJECT = encodeURIComponent(`I'm interested in the deal "${ auction.name }"`);

    let isVisible = false;

    const toggleTooltipVisibility = (): void => {
        isVisible = !isVisible;
    };

    const createBidModal = (auction: Auction): void => {
        const DATA = {
            allowsPartial: auction.allowsPartialBids,
            auctionKey: auction._.key,
        };

        openModal('#create-bid', DATA);
    };

</script>

<footer class = 's8-auction-footer'>

    <div class = 's8-contact'>

        {#if $SESSION !== null && !isPreview}

            <UserItem key = { $SESSION.organization.managerKey } let:user>
                <OutputUser
                    { user }
                    heading = 'Need a Custom Deal?'
                    subject = { SUBJECT }
                />
            </UserItem>

        {/if}

    </div>

    <div class = 's8-buttons'>

        <div class = 's8-wrap-large'>

            <div class = 's8-item'>

                <Button
                    icon = 'file'
                    url = '#auction-info'
                    style = 'solid'
                    color = 'dark'
                    css = 'w-9 !h-9 !px-0 mx-auto block shrink-0'
                />
                <span class = 's8-label'>Info</span>

            </div>

            {#if isPreview}

                <div class = 's8-item'>
                    <Button
                        icon = 'download'
                        url = '#authentication-download'
                        style = 'solid'
                        color = 'dark'
                        css = 'w-9 !h-9 !px-0 mx-auto block shrink-0'
                    />
                    <span class = 's8-label'>Download</span>
                </div>

            {:else if !isPreview && !auction.isReserved }

                <div class = 's8-item'>
                    <AuctionItemDownload auctionKey = { auction._.key }/>
                    <span class = 's8-label'>Download</span>
                </div>
            {/if}

        </div>

        <div class = 's8-wrap-small'>

            <Tooltip position = 'south' { isVisible } css = '!w-auto'>

                <div class = 's8-item !pt-2'>

                    <Button
                        icon = 'file'
                        url = '#auction-info'
                        style = 'solid'
                        color = 'dark'
                        css = 'w-9 !h-9 !px-0 mx-auto block shrink-0'
                    />
                    <span class = 's8-label'>Info</span>

                </div>

                {#if isPreview}

                    <div class = 's8-item'>
                        <Button
                            icon = 'download'
                            url = '#authentication-download'
                            style = 'solid'
                            color = 'dark'
                            css = 'w-9 !h-9 !px-0 mx-auto block shrink-0'
                        />
                        <span class = 's8-label'>Download</span>
                    </div>

                {:else if !isPreview && !auction.isReserved }

                    <div class = 's8-item'>
                        <AuctionItemDownload auctionKey = { auction._.key }/>
                        <span class = 's8-label'>Download</span>
                    </div>

                {/if}

            </Tooltip>

            <Button
                icon = 'more'
                style = 'solid'
                color = 'dark'
                css = 'w-9 !h-9 !px-0 mx-auto block shrink-0'
                on:click = { toggleTooltipVisibility }
            />

        </div>

        {#if isPreview }

            <Button
                label = 'Login / Register'
                url = '#authentication'
                icon = 'arrowRight'
                css = 'ml-1'
                color = 'danger'
            />

        {:else if auction.isReserved }
            <AuctionReservedBidForm { auction } />
        {:else}

            <Button
                label = { 'I\'m interested' }
                on:click = { createBidModal.bind(null, auction) }
                icon = 'arrowRight'
                css = 'ml-1'
            />

        {/if}

    </div>
</footer>

<Modal hash = '#auction-info' width = { 'auto' } height = 'inherit'>
    <AuctionItemInfo { auction } />
</Modal>

<style lang='postcss'>

    footer.s8-auction-footer {
        @apply bg-light shadow-lg fixed left-0 right-0 bottom-0 p-2 sm:p-4 pb-3 z-30 flex justify-between border-t border-grey-200 h-14 sm:h-20;

        div.s8-buttons {
            @apply flex;

            div.s8-wrap-large {
                @apply hidden sm:flex;
            }

            div.s8-wrap-small {
                @apply block sm:hidden relative;
            }

            div.s8-item {
                @apply relative flex flex-col gap-y-0.5 items-center sm:w-10 p-1 sm:p-0;
            }

            span.s8-label {
                @apply text-xxxs w-full text-center block;
            }
        }

        div.s8-contact {
            @apply flex-none;
            margin: -3px 0px 0px -3px;
        }

        @media (min-width: 950px) {
            div.s8-contact {
                @apply block;
                margin: 0px;
            }
        }
    }

</style>